import { request } from '@/config/request/interceptors'
import type { Commit, Dispatch } from 'vuex'

export default {
  namespaced: true,
  state: {
    userInfo: {},
    token: window.localStorage.getItem('token') ?? ''
  },
  getters: {},
  mutations: {
    SET_TOKEN: (state: any, token: string) => {
      state.token = token
      window.localStorage.setItem('token', token)
    },
    SET_USER_INFO: (state: any, userInfo: any) => {
      state.userInfo = userInfo
    }
  },
  actions: {
    GET_USER_INFO: async ({ commit, state }: { commit: Commit; state: { token: string } }) => {
      if (!state.token) return
      const res = await request.customer.getCustomerDetail.getCustomerDetail({ token: state.token }).catch(() => {
        commit('SET_TOKEN', '')
      })
      commit('SET_USER_INFO', res?.data ?? {})
    },
    changeToken: ({ commit }: { commit: Commit }, token: string) => {
      commit('SET_TOKEN', token)
      if (!token) {
        window.location.href = '/'
      }
    }
  }
}
